//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { oa_catalog, term, file, schoolClass, grade } from "@/api/server";

import { all_staff } from "@/api/common";
import { Drawer } from 'iview';
import selectCatalog from "@/components/catalog/selectCatalog.vue";
import editInline from "@/components/file/editInline.vue";
import { mapState } from 'vuex'
import formatter from "@/mixins/formatter"
import dateTimeFormatter from '@/mixins/date-time-formatter'
import addForm from '@/views/oa_catalog/add-form'
import compressList from "@/components/catalog/compress.vue";
import elFormHeader from '@/components/el-form-header'
import FolderMixin from './folder-mixin'
export default {
	mixins: [formatter, dateTimeFormatter, FolderMixin],
	data() {
		return {
			selectMode: 1,
			batchStatus: '',
			addFormVisible: false,
			typeList: [
				{ name: '我和班级的资料', id: 0 },
				{ name: '我审核的', id: 1 },
				{ name: '公共资料库', id: 2 },
			],
			loading: false,
			editForm: {
				visible: false,
				fileData: {}
			},
			moveFileFlag: false,
			filterText: "",
			attachment: [],
			file_ids: [],
			catalogId: "0",
			termList: [],
			inGradeList: [], // 可以被选择的年级
			list: {
				data: [],
				page: 1,
				total: 0,
				loading: false,
				loading_text: "",
				size: 10,
			},
			filters: {
				my: false,
				my_check: false,
				name: '',
				term_id: null,
				author: null,
				class_id: null,
				catalog_id: null,
				page: 1,
				size: 10

			},
			tree: [],
			selectId: null,
			current_path_str: '',
			allUserList: [],
			currentTag: 0,
			currentNode: {},
			permission: 0,
			is_compress: false,
			classList: [],

		};
	},
	computed: {
		...mapState('school', ['schoolYearList', 'gradeList', 'schoolConfig', 'schoolDate']),

		// 是否可以上传
		canUpload() {
			return this.currentTag != 1
				&& this.permission > 0
				&& (this.permission | 1) == this.permission
				&& this.currentNode.status != 0
				&& !this.currentNode.relate
		}
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
	},
	methods: {
		selectInit(row, index) {
			// 判断是否可选
			switch (this.currentTag) {
				case 0:
					return this.schoolConfig.manage_my_files && row.school_date.term_no == this.schoolDate.term_no
				default:
					if (this.batchStatus == '') return false
					const permit = this.batchStatus == 'move' ? 4 : 8
					console.log(permit)
					return !this.currentNode.relate && row.one_permit > 0 && (row.one_permit | permit) == row.one_permit
			}

		},
		changeTags(data, index) {
			this.currentTag = data.id;
			this.catalogId = null;
			this.current_path_str = '';
			this.permission = 0;
			this.batchStatus = ''
			this.getCatalogList();
			if (this.currentTag == 2) {
				this.getTree();
			}
		},
		showWps(file, wps_url, one) {
			if (this.currentTag == 2 && ((one > 0 && (one | 2) != one) || one == 0)) {
				this.$message({ message: "暂无查看权限!", type: "error" });
				return
			}
			let item = { path: file.path, name: file.name, wps_url: wps_url };
			this.$refs.myEditInline.showWps(item);
		},

		handleSizeChange(val) {
			this.filters.size = val;
			this.getCatalogList();
		},
		handleCurrentChange(val) {
			this.filters.page = val;
			this.getCatalogList();
		},
		formatterTime(data) {
			return this.formatterStandard(data.add_time * 1000);
		},

		filterNode(value, data) {
			if (!value) return true;
			return data.name.indexOf(value) !== -1;
		},

		getTree() {
			oa_catalog.getCatalogTree({ role_ids: null, all: true }).then(res => {
				this.tree = res.data;
				this.tree.forEach(v => {
					v.permission = v.permission ? v.permission : 0;
				})
			});
		},

		find: function (data) {
			data.checked = false;
			if (data.children && data.children.length > 0) {
				data.children.forEach(e => {
					this.find(e);
				})
			}
		},
		handleNodeClick(data, Node) {
			if (!data.allow && this.currentTag == 2) {
				this.$message({ message: "暂无权限!", type: "error" });
				return
			}
			this.currentNode = data
			this.list.page = 1;
			this.catalogId = data.id;
			this.permission = data.permission;

			this.current_path_str = data.name;
			this.list.page = 1;
			this.getCatalogList();
			this.tree.forEach(v => {
				this.find(v);
			})
			data.checked = true;
		},

		onSelectCancel(e) {
			this.batchStatus = ''
			this.$refs.fileListTable.clearSelection()
		},
		showRenameForm(data) {
			this.selectId = data.id;
			this.renameForm.data.name = data.name;
			this.renameForm.visible = true;
		},

		move() {
			this.is_compress = false;
			this.$nextTick(() => {
				this.$refs.allTreeRef.openAllTree();
			});
			this.moveFileFlag = true;
			this.batchStatus = ''

		},

		moveContent() {
			if (this.file_ids.length == 0) {
				this.$message({ message: "未选择文件", type: "info" });
				return
			}
			this.$confirm(`确认要移动所选文件吗?`, "提示", {
				type: "warning"
			}).then(() => {
				oa_catalog.moveContent({ ids: this.file_ids, catalog_id: this.catalogId }).then(res => {
					if (res.data) {
						this.$message({ message: "移动成功！", type: "success" });
						this.file_ids = [];
						this.moveFileFlag = false;
						this.getCatalogList();
					} else {
						this.$message({ message: res.data.msg, type: "error" });
					}
				});
			}).catch(() => { });
		},

		deleteAll() {
			if (this.file_ids.length == 0) {
				this.$message({ message: "未选择文件", type: "info" });
				return
			}
			this.$confirm(`删除后将不能恢复，确认要删除吗?`, "警告", { type: 'warning' }).then(() => {
				let len = 0;
				this.file_ids.forEach(v => {
					let param = { id: v }
					oa_catalog.fileRemove(param).then(res => {
						if (res.data) {
							len = len + 1;
							if (len == this.file_ids.length) {
								this.$message({ message: "删除成功！", type: "success" });
								this.getCatalogList();
							}
						}
						this.batchStatus = ''
					});
				});
			})
		},

		toGetList() {
			this.list.page = 1;
			this.filters.page = 1
			this.getCatalogList();
		},

		getCatalogList() {
			this.filters.my_check = false
			this.filters.my = false
			if (this.currentTag == 1) {
				this.filters.my_check = true
			} else if (this.currentTag == 0) {
				this.filters.my = true
			}
			this.filters.catalog_id = this.catalogId
			this.list.loading = true;
			oa_catalog.paginate(this.filters).then(res => {
				this.list.loading = false;
				if (res.data) {
					this.list.total = res.data.totalRow;
					this.list.data = res.data.list;
					this.list.data.forEach(r => {
						r.one_permit = r.catalog && r.catalog.permission ? r.catalog.permission : 0
					})
				} else {
					this.list.data = [];
				}
			});
		},
		handleChange(value) {
			this.uploadForm.data.term_id = value;
		},
		handleChangeTerm(value) {
			this.editTerm.data.term_id = value;
		},
		getCurrentCatalog(data) {
			if (!data.id || data.id == '0') {
				this.$message({ message: "请选择文件归档目录!", type: "error" });
				this.is_compress = false;
				this.$nextTick(() => {
					this.$refs.allTreeRef.openAllTree();
				});
				return
			}
			this.catalogId = data.id;
			this.current_path_str = data.name;
			if (!this.moveFileFlag) {
				this.uploadForm.visible = true;
			} else {
				this.moveContent();
			}
		},
		handleSelectionChange(val) {
			this.file_ids = val.map(v => {
				return v.id;
			})
		},
		toCompressDownload() {
			this.is_compress = true;
			this.$nextTick(() => {
				this.$refs.refCompress.openAllTree();
			});
		},
		getClassList(schoolYear) {
			schoolClass.getSimpleClassList({ school_year: schoolYear }).then(res => {
				if (res.data) {
					this.classList = res.data.map(r => {
						return {
							id: r.class_id,
							grade_id: r.grade_id,
							name: r.grade + r.name
						}
					})
				}
			})
		},

		onClassChange(e) {
			if (e) {
				this.filters.class_id = e
				let classInfo = this.classList.find(v => v.id == e)
				this.inGradeList = this.gradeList.filter(v => v.id <= classInfo.grade_id)
			} else {
				this.filters.class_id = null
			}
			this.filters.grade_id = null
			this.toGetList()
		},
		onGradeChange(e) {
			this.filters.grade_id = e
			this.toGetList()
		},
		onSchoolYear(e) {
			this.filters.school_year = e
			this.filters.term_no = null
			this.filters.class_id = null
			this.toGetList()
			this.getClassList(e)
		},
		onTermNo(e) {
			if (!this.filters.school_year) {
				this.$message.warning('请先选择学年')
				return
			}
			this.filters.term_no = e
			this.toGetList()
		},
		onSelectModel() {
			this.filters.class_id = null
			this.filters.grade_id = null
			this.filters.term_no = null
			this.filters.school_year = null
			this.getClassList()
			this.toGetList()
		},
		showEdit(info) {
			this.editForm.fileData = {
				id: info.id,
				catalog_id: info.catalog ? info.catalog.id : null,
				name: info.name,
				class_id: info.class_info ? info.class_info.class_id : null,
				term_no: info.school_date ? (info.school_date.term_no + '').substring(4) : null,
				school_year: info.school_date ? info.school_date.year : null
			};
			this.editForm.visible = true
		},
		onEditClose() {
			this.editForm = {
				visible: false,
				fileData: {}
			}
		}


	},

	components: {
		Drawer,
		selectCatalog,
		editInline,
		compressList,
		addForm,
		elFormHeader
	},

	mounted() {
		this.getTree();
		this.catalogId = null;
		this.currentTag = 0;
		this.getCatalogList();
		all_staff.getAllUser().then(res => {
			if (res.data) {
				this.allUserList = res.data.schoolUserList;
			}
		})
		this.getClassList()
	}
};



// WEBPACK FOOTER //
// ./src/views/oa_catalog/index.vue